var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ModuleValueGeneral, SchemaModuleGeneral } from './module-general';
import * as rawJSONSchemaModuleColposcopy from '../../schemas/module-colposcopy.json';
var ModuleValueColposcopy = (function (_super) {
    __extends(ModuleValueColposcopy, _super);
    function ModuleValueColposcopy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ModuleValueColposcopy;
}(ModuleValueGeneral));
var SchemaModuleColposcopy = (function (_super) {
    __extends(SchemaModuleColposcopy, _super);
    function SchemaModuleColposcopy() {
        var _this = _super.call(this) || this;
        _this.loadSchema(rawJSONSchemaModuleColposcopy);
        return _this;
    }
    SchemaModuleColposcopy.prototype.hook = function (form) {
        _super.prototype.hook.call(this, form);
        this.listenValue('colposcopy_date', this.fieldHandlerCopyValue('biopsy_date').bind(this));
    };
    SchemaModuleColposcopy.prototype.setupValidators = function () {
        _super.prototype.setupValidators.call(this);
        this.validatorDateComparison('date_of_referral', 'date_of_birth', '>');
        this.validatorDateComparison('colposcopy_date', 'date_of_birth', '>');
        this.validatorDateComparison('colposcopy_date', 'date_of_referral', '>=');
        this.validatorDateComparison('biopsy_date', 'date_of_birth', '>');
        this.validatorDateComparison('biopsy_date', 'date_of_referral', '>=');
        this.validatorDateComparison('date_of_treatment', 'date_of_birth', '>');
        this.validatorDateComparison('date_of_treatment', 'date_of_referral', '>=');
        this.validatorDate('date_of_birth', (new Date()), '<=', function (v) { return new Date(v); });
    };
    return SchemaModuleColposcopy;
}(SchemaModuleGeneral));
export { SchemaModuleColposcopy };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-colposcopy.ts.pre-build-optimizer.js